import { iocNames } from '../iocNames';
import { Handlers } from '../types/common';
import { useInject } from './useInject';

export function useHandlers() {
  return useInject<Handlers>(iocNames.handlers);
}
